import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
    selector: 'app-support-login',
    templateUrl: './support-login.component.html',
    styleUrls: ['./support-login.component.scss']
})
export class SupportLoginComponent {

    constructor(
        private translation: TranslateService,
        private titleService: Title,
    ) {
        this.titleService.setTitle(translation.instant('MENU.ITEM.SUPPORT') + ' - InviteDesk');
    }

}
